<template>
  <div id="lookups" class="wrrapper">
    <page-heading title="Add Lookups">
      <template #content>
        <div class="flex align-center">
          <div class="lookup-search mr-2">
            <div class="lookup-search-wrapper flex align-center">
              <input
                type="text"
                placeholder="Search..."
                v-model="searchQuery"
              />
              <span
                v-if="searchQuery"
                class="cursor mdi mdi-24px mdi-close lookup-search-clear"
                @click="handleResetSearch"
              ></span>
              <span class="mdi mdi-24px mdi-magnify lookup-search-icon"></span>
            </div>
          </div>
          <Select
            :options="listLookupsType"
            :placeholder="'Filter by'"
            styles="mr-2"
            :input="sortLookups"
          />
          <Button
            :onClick="handleAdd"
            title="Add Lookups"
            className="button--primary"
          />
        </div>
      </template>
    </page-heading>
    <div class="content">
      <data-table
        :cols="columns"
        :rows="filteredLookups"
        height="calc(100vh - 15rem)"
        :loading="loading"
        ><template slot="action" slot-scope="actions">
          <dropdown-menu
            :rowData="actions"
            :items="items"
            :handleItemClick="handleItems"
          />
        </template>
      </data-table>
    </div>
    <modal
      name="lookupsAdd"
      title="Add Lookups"
      class="custom-modal"
      height="auto"
      width="600"
    >
      <template v-slot:content>
        <div class="add-lookups mt-1">
          <validation-observer ref="lookups">
            <div>
              <validation-provider rules="required" v-slot="{ errors }">
                <Input
                  label="Name"
                  class="doctor-input mb-base"
                  type="text"
                  :error="errors[0]"
                  v-model="lookups.name"
                />
              </validation-provider>
              <validation-provider rules="required" v-slot="{ errors }">
                <Input
                  label="Type"
                  class="doctor-input mb-base"
                  type="text"
                  :error="errors[0]"
                  v-model="lookups.type"
                />
              </validation-provider>
              <Input
                label="Description"
                class="doctor-input mb-base"
                type="text"
                v-model="lookups.description"
              />
              <Input
                label="Cell Number"
                class="doctor-input mb-base"
                type="text"
                v-model="lookups.cell_no"
              />
              <Button
                title="Save"
                className="button--primary"
                :loader="loading"
                :onClick="handleDoctors"
              />
            </div>
          </validation-observer>
        </div>
      </template>
    </modal>
    <Update />
  </div>
</template>

<script>
import DataTable from "@/components/DataTable";
import Select from "@/components/Select";
import DropdownMenu from "@/components/DropdownMenu";
import Button from "@/components/Button";
import Input from "@/components/Input";
import Modal from "@/components/Modal";
import Update from "./update";
import { mapGetters, mapActions } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";
export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    DropdownMenu,
    Update,
    DataTable,
    Select,
    Button,
    Modal,
    Input
  },
  data() {
    return {
      searchQuery: "",
      lookups: {},
      items: ["Edit", "Delete"],
      columns: [
        { column: "serial", label: "#", width: "60" },
        { column: "name", label: "Name", sortable: true },
        { column: "cell_no", label: "Cell Number", sortable: true },
        { column: "type", label: "Type", sortable: true },
        {
          column: "description",
          label: "Description",
          sortable: true,
          sort: true
        },
        { column: "action", label: "Action" }
      ]
    };
  },
  methods: {
    ...mapActions("doctors", [
      "doctorList",
      "addDoctors",
      "deleteDoctor",
      "lookupsTypes",
      "lookupView"
    ]),
    handleAdd() {
      this.$modal.show("lookupsAdd");
    },
    handleDoctors() {
      this.$refs.lookups.validate().then(success => {
        if (!success) {
          return;
        }
        this.addDoctors({
          ...this.lookups,
          isOther:
            this.$store &&
            this.$store.state &&
            this.$store.state.auth.user.isOther
        }).then(() => {
          this.lookups = {};
          this.$modal.hide("lookupsAdd");
          this.$refs.lookups.reset();
        });
      });
    },
    handleItems(val, rowData) {
      const id = rowData.actions.id;
      if (val == "Edit") {
        this.lookupView(id);
        this.$modal.show("updateLookups");
      } else if (val == "Delete") {
        this.deleteDoctor(id).then(() => {});
      }
    },
    sortLookups(val) {
      if (val) {
        this.doctorList(val.name.toLowerCase()).then(() => {
          this.lookupsTypes();
        });
      } else {
        this.doctorList();
      }
    },
    handleResetSearch() {
      this.searchQuery = "";
    }
  },
  computed: {
    ...mapGetters({
      listDoctors: "doctors/listDoctors",
      filterLookups: "doctors/filterLookups",
      role: "auth/role",
      loading: "loading"
    }),
    filteredLookups() {
      const rows = this.listDoctors || [];
      const query = this.searchQuery.trim().toLowerCase();
      if (!query) {
        return rows;
      }
      return rows.filter(item => {
        const name = String(item.name || "").toLowerCase();
        const cellNo = String(item.cell_no || "").toLowerCase();
        const type = String(item.type || "").toLowerCase();
        const description = String(item.description || "").toLowerCase();
        return (
          name.includes(query) ||
          cellNo.includes(query) ||
          type.includes(query) ||
          description.includes(query)
        );
      });
    },
    userRole() {
      return this.role && this.role.find(item => item);
    },
    listLookupsType() {
      let items = [];
      this.filterLookups &&
        this.filterLookups.map((item, index) =>
          items.push({
            name: item.type,
            key: index
          })
        );
      return items;
    }
  },
  mounted() {
    this.doctorList();
    this.lookupsTypes();
  }
};
</script>

<style scoped>
.lookup-search input {
  width: 100%;
  padding: 0 8px;
  outline: none;
  background: var(--surface);
  box-sizing: border-box;
  font-size: var(--fs-body);
  line-height: 1.4;
  color: var(--text);
  margin: 0;
  border: none;
  font-family: var(--font-sans);
}

.lookup-search-wrapper {
  border: 1px solid var(--line);
  border-radius: var(--radius-md);
  height: 36px;
  min-width: 220px;
  background: var(--surface);
  overflow: hidden;
}

.lookup-search-wrapper:focus-within {
  border-color: var(--accent-600);
  box-shadow: var(--ring);
}

.lookup-search-clear {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--muted-soft);
  padding: 0 6px;
}

.lookup-search-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  width: 36px;
  color: var(--muted-soft);
  background: var(--surface-2);
  border-left: 1px solid var(--line);
  padding: 0;
  box-sizing: border-box;
}
</style>
